import React, { Component } from 'react'; //different
//import './style.css';
import instance from "./axios-instance";
import SweetAlert from 'react-bootstrap-sweetalert';
import jwt_decode from "jwt-decode";
import NavMenu from './navmenu';
import Systems from "./SystemFunction";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

var settings = {
    dots: true,
    infinite: true,
    slidesToShow: (window.innerWidth <= 760) ? 1 : 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 3000,
    cssEase: "linear"
};
class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tabbannerlist: [],
        }

    }
    componentDidMount() {
        const cacheKey = "tabBannerListCache";
        const cacheTTL = 3 * 60 * 60 * 1000; // 3 ชั่วโมงในมิลลิวินาที
        const cachedData = JSON.parse(localStorage.getItem(cacheKey));

        // ตรวจสอบแคช
        if (cachedData && (Date.now() - cachedData.timestamp < cacheTTL)) {
            console.log("Using cached data for tabbannerlist");
            this.setState({ tabbannerlist: cachedData.data });
        } else {
            // ถ้าไม่มีแคชหรือแคชหมดอายุ ให้เรียก API
            instance.get("/api/v1/tabbannerlist?System=" + Systems)
                .then((res) => {
                    console.log("tabbannerlist", res.data);
                    if (res.data.status === 200) {
                        this.setState({ tabbannerlist: res.data.message });

                        // บันทึกข้อมูลลงในแคช
                        localStorage.setItem(cacheKey, JSON.stringify({
                            timestamp: Date.now(),
                            data: res.data.message,
                        }));
                    }
                }).catch((err) => {
                    console.error("Error fetching tabbannerlist:", err);
                });
        }
    }


    render() {
        const { tabbannerlist } = this.state
        return (
            <>
                <div className="px-0 card-width-banner" data-v-8a7c0ea5="">
                    <div
                        className="flicking-viewport"
                        data-v-8a7c0ea5=""
                        style={{
                            userSelect: "none",
                            WebkitUserDrag: "none",
                            touchAction: "pan-y"
                        }}
                    >
                        <Slider {...settings}>
                            {tabbannerlist.length > 0 ? (
                                tabbannerlist.map((item, index) => (
                                    <div>
                                        <img
                                            src={item?.path}
                                            alt={"Slide " + index}
                                            style={{ borderRadius: "0.5rem", width: "100%" }}
                                        />
                                    </div>
                                ))
                            ) : ""}
                        </Slider>
                        <div
                            className="flicking-pagination flicking-pagination-bullets"
                            data-v-8a7c0ea5=""
                        >
                        </div>
                    </div>
                </div>
            </>

        );
    }
}
export default App;
